import { Button, Link } from '@heroui/react';

export const FavoriteListStatus = ({
  variant = 'empty',
}: {
  variant?: 'empty';
}) => {
  if (variant === 'empty') {
    return (
      <div className="flex flex-col items-center h-full justify-center text-[#9CA5AC] text-sm">
        <p className="text-[#222222] font-semibold text-lg text-center">
          В избранном пусто
        </p>
        <p className="text-[#60656C] text-sm text-center max-w-60 lg:max-w-72 mt-3">
          Сохраняйте лекарства и товары, которые хотите купить позже
        </p>
        <Button color="primary" size="lg" className="mt-6" as={Link} href="/">
          На главную
        </Button>
      </div>
    );
  }
  return null;
};
